import React from 'react';
import ReactDOM from 'react-dom/client'
import i18next from "i18next"
import { I18nextProvider } from "react-i18next"
import App from './App';
import reportWebVitals from './reportWebVitals'

declare global {
  interface Window { 
    yuzuBaseURL: string
    bookingTranslations: { [key: string]: string; }
  }
}

const windowBookingTranslations = window.bookingTranslations || {}

i18next.init({
    lng: "en", // Set initial language
    fallbackLng: "en",
    resources: {
        "en": { translation: windowBookingTranslations }, // Load translations dynamically
    },
})

const root = ReactDOM.createRoot(
  document.getElementById('select-course-app') as HTMLElement
)

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
